import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import ImageCropper from '../views/ImageCropper.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/image-cropper',
    name: 'ImageCropper',
    component: ImageCropper
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
